export default __webpack_public_path__ + "static/media/poster-visita.b52f3764.jpg";